import(/* webpackMode: "eager", webpackExports: ["FaqContent"] */ "/vercel/path0/src/components/faq/FaqContent.tsx");
